import GlobalSearch from "./search/GlobalSearch";
import ProfileDropDown from "./ProfileDropDown";
import { MenuAlt4Icon } from "@heroicons/react/solid";
import { useState } from "react";
import "./header.css";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import {
  COMPANY_EMPLOYEE_ID,
  COMPANY_ID,
  COMPANYNAME,
  IS_CHAT,
  IS_HRMS,
  IS_LIVE_TRACKING,
  NAME,
  REDIRECT_URL,
  ROLE,
  ROLES,
  SERVICE_KEY,
  TOKEN_NAME,
  USERNAME,
} from "../config";
import { Button } from "./ui";
import { getCookieDomain } from "../utility";
import { useOnboardingContext } from "../context/OnboardingContext";
import { MdCheck, MdArrowForward } from "react-icons/md";
import ToolTip from "./ui/ToolTip";
import useAppBrandInfo from "../hooks/useAppBrandInfo";

const cookies = new Cookies();

function Header({ onMenuClick, onProfileClick, hasAccess = true }) {
  const [isShowDropDown, setIsShowDropDown] = useState(false);
  const { isPending, progressPercent, cards, handleStartSetup } = useOnboardingContext();
  const { data: brandInfo } = useAppBrandInfo();
  
  const handleMenuToggle = () => {
    onMenuClick();
    setIsShowDropDown(false);
  };

  const handleProfileToggle = () => {
    setIsShowDropDown(!isShowDropDown);
    onProfileClick();
  };

  const userRole = cookies.get(ROLE);

  const handleLogout = () => {
    const cookieNames = [
      TOKEN_NAME,
      COMPANYNAME,
      NAME,
      COMPANY_ID,
      ROLE,
      USERNAME,
      COMPANY_EMPLOYEE_ID,
      IS_LIVE_TRACKING,
      IS_CHAT,
      IS_HRMS,
    ];

    const baseOptions = {
      path: "/",
      domain: getCookieDomain(),
      secure: window.location.protocol === "https:",
      sameSite: "lax",
    };

    for (let i = 0; i < cookieNames.length; i++) {
      cookies.remove(cookieNames[i], baseOptions);
    }

    localStorage.clear();
    window.location.href = `${REDIRECT_URL}?pid=${SERVICE_KEY}`;
  };

  const isAdmin = userRole === ROLES.COMPANY_ADMIN;

  return (
    <>
      <div className="text-black bg-white h-16 px-4 fixed top-0 mb-4 z-[1001] w-full shadow-lg flex items-center justify-between">
        <Link to="/" className="flex items-center shrink-0">
          <img
            src={brandInfo?.app_logo_url || "/idom-logo.webp"}
            alt={`${brandInfo?.app_name || "iDoM"} Logo`}
            className="hidden sm:block h-10 w-auto md:h-12 object-contain"
          />
          <img
            src={brandInfo?.fav_icon_url || "/favicon.jpg"}
            alt={`${brandInfo?.app_name || "iDoM"} Logo`}
            className="block sm:hidden h-9 w-9 rounded object-contain"
          />
        </Link>
        
        {isPending && isAdmin && hasAccess && (
          <div className="hidden lg:flex flex-row items-center justify-center flex-1 min-w-0 max-w-[700px] mx-4 gap-3">
            <span className="text-sm font-semibold text-gray-700 whitespace-nowrap">Setup Progress</span>
            
            <div className="flex items-center justify-between w-full relative">
              {/* Background line */}
              <div className="absolute top-1/2 left-0 right-0 h-[2px] bg-gray-200 -z-10 -translate-y-1/2"></div>

              {cards?.map((card, index) => (
                <ToolTip key={card.id} content={card.title.replace('\n', ' ')}>
                  <div 
                    onClick={() => handleStartSetup(card.path)}
                    className={`cursor-pointer hover:scale-110 w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold border-2 transition-all duration-300 z-10 ${
                      card.completed 
                        ? 'bg-primary border-primary text-white' 
                        : 'bg-white border-gray-300 text-gray-400 hover:border-primary/50'
                    }`}
                  >
                    {card.completed ? <MdCheck size={16} /> : (index + 1)}
                  </div>
                </ToolTip>
              ))}
            </div>
            
            <Link to="/onboarding" className="text-sm text-primary hover:underline whitespace-nowrap inline-flex items-center gap-1">
              <span>Continue Setup</span>
              <MdArrowForward className="text-[14px]" />
            </Link>
          </div>
        )}

        <div className="flex items-center justify-between h-full shrink-0 ml-auto">
          <GlobalSearch onOpen={onProfileClick} />
          <div className="flex items-center gap-2">
            {/* Mobile user profile button */}
            <div className="relative lg:hidden">
              <ProfileDropDown handleLogout={handleLogout} />
            </div>

            <div className="block lg:hidden">
              <Button 
                size={"icon"} 
                variant={"ghost"} 
                onClick={handleMenuToggle}
                onMouseDown={(e) => e.stopPropagation()}
              >
                <MenuAlt4Icon className="w-6 h-6" />
              </Button>
            </div>
          </div>
          <div className="relative hidden lg:block">
            <ProfileDropDown handleLogout={handleLogout} />
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
